import { BiometricIdentityVerificationRequestStatus } from "@wingspanhq/wingspan-api-sdk";

import { StepItem } from "../../../../../../shared/components/Steps";

/** The request status is v1's three-value status verbatim. */
export const getIdentityVerificationPayeeProgressSteps = (
  status: BiometricIdentityVerificationRequestStatus
): StepItem[] => {
  if (status === BiometricIdentityVerificationRequestStatus.COMPLETE) {
    return [
      { title: "Start", status: "Complete" },
      { title: "Processed", status: "Complete" },
      { title: "Complete", status: "Complete" }
    ];
  }

  if (status === BiometricIdentityVerificationRequestStatus.FAILED) {
    return [
      { title: "Start", status: "Complete" },
      { title: "Processed", status: "Failed" },
      { title: "Complete", status: "Pending" }
    ];
  }

  return [
    { title: "Start", status: "Active" },
    { title: "Processed", status: "Pending" },
    { title: "Complete", status: "Pending" }
  ];
};
